module.exports = __webpack_public_path__ + "static/media/clothSwap.2fda2b62.png";